import { render, staticRenderFns } from "./VerifiedEmail.vue?vue&type=template&id=0b6a3de0"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6a3de0')) {
      api.createRecord('0b6a3de0', component.options)
    } else {
      api.reload('0b6a3de0', component.options)
    }
    module.hot.accept("./VerifiedEmail.vue?vue&type=template&id=0b6a3de0", function () {
      api.rerender('0b6a3de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/VerifiedEmail.vue"
export default component.exports